export const main = {
  base_color: '#464ac9',
};
